import React, { useEffect } from "react";
import Header from "../../../components/header";
import "./childrin&education.css";
import HomeVideo from "../../../assets/childrin&education_background.webp";
import { ParallaxProvider } from "react-scroll-parallax";
import TargetsCharts from "./TargetsCharts";
import Spotlight from "./spotlight";
import FlipCard from "./FlipCard";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowDown } from "@fortawesome/free-solid-svg-icons";

import Aos from "aos";
import "aos/dist/aos.css";

export default function ChildrinEducation() {

  const handleScrollToNext = () => {
    const nextSection = document.getElementById("health");
    if (nextSection) {
      nextSection.scrollIntoView({ behavior: "smooth" });
    }
  };

  useEffect(() => {
    Aos.init({ duration: 2000 });
  }, []);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <ParallaxProvider>
      <div className="screen-page">
        <Header />
        {/* section 01 */}
        <div style={{ position: "relative" }}>
          <div className="home-page-video">
            <div>
              <img
                src={HomeVideo}
                style={{ height: "calc(100vh - 120px)", width: "100%", objectFit: "cover" }}
                alt=""
              />
            </div>
          </div>

          {/* <div style={{ marginLeft: "20px" }}>
            <div className="childrin-education-text-box">
              <div>
                <Parallax speed={10}>
                  <h1 className="childrin-education-topic-home">
                    Children & <br />
                    Education
                  </h1>
                </Parallax>
              </div>
            </div>
          </div> */}

          {/* White Box */}
          <div className="white-box">
            <div className="white-box-container">
              {/* <h1>
                Modern <span className="white-box-container-h1">& Unique</span>
              </h1> */}
              <div className="screen-pc">
                <h1 className="white-box-container-h1-text">
                  {/* Conserve <br /> */}
                  <span className="white-box-container-h1">Children & <br />
                    Education</span>
                </h1>
              </div>

              <div className="screen-mobile">
                <p className="white-box-container-h1-text">
                {/* Conserve <br /> */}
                  <span className="white-box-container-h1">
                  Children & <br />
                    Education <br />
                  </span>
                </p>
              </div>

              {/* Button to scroll to the next section */}
              <div onClick={handleScrollToNext} className="scroll-button">
                <FontAwesomeIcon icon={faArrowDown} style={{ fontSize: "16px" }} />
              </div>
            </div>
          </div>

          <div
            style={{
              position: "absolute",
              top: 0,
              left: 0,
              width: "100%",
              height: "calc(100vh - 120px)",
              backgroundColor: "rgba(0, 0, 0, 0.25)",
              zIndex: 0,
            }}
          ></div>

          {/* H Letter Design */}
          <div className="h-banner-container">
            {/* Left Section */}
            <div
              className="h-design slider-left-time"
              style={{ animationDelay: "0.4s" }}
            >
              <div className="h-left"></div>
            </div>

            {/* Middle Section */}
            <div
              className="h-design slider-left-time"
              style={{ animationDelay: "0.4s" }}
            >
              <div className="h-design-N">
                <div className="h-left-N"></div>
                <div style={{ height: "350px" }} />
                <div className="h-right-N"></div>
              </div>
            </div>

            {/* Right Section */}
            <div
              className="h-design slider-left-time"
              style={{ animationDelay: "0.4s" }}
            >
              <div className="h-right"></div>
            </div>
          </div>

        </div>

        {/* section-2 */}
        <div style={{ backgroundColor: "#f5f5f5", color: "#404040" }}>
          <center>
            <div className="childrin-education-page-para-2">
              <p data-aos="fade-in" data-aos-once="true" id="health">
                Health. Wellbeing. Education. These are the core foundations for
                a better future for our children. It deserves our focus and
                investment.
              </p>
            </div>
          </center>
        </div>

        {/* section-3 */}
        <TargetsCharts />

        {/* section-4 */}
        <Spotlight />

        {/* Section - 5 */}
        <FlipCard />
      </div>
    </ParallaxProvider>
  );
}
